import { useNewsListCtrl } from "@/components/NewsMain/Default/hooks/useNewsList";

export function useListenScroll() {
  const { setNewsList } = useNewsListCtrl();
  useEffect(() => {
    // const container = document.querySelector(".app-container");
    const container = document.documentElement;
    if (!container) {
      return;
    }
    const Fn = () => {
      const scrollNewsListY = container.scrollTop;
      setNewsList(prev => {
        return {
          ...prev,
          scrollNewsListY,
        };
      });
    };
    container.addEventListener("scroll", Fn);
    return () => {
      container.removeEventListener("scroll", Fn);
    };
  }, []);
}
